$(document).ready(function () {
  $(".ProductCarousel").owlCarousel({
    nav: true,
    dots: true,
    loop: true,
    autoplay: true,
    slideSpeed: 3000,
    margin: 10,
    responsiveClass: true,
    navText: ['<span class="left"></span>', '<span class="right"></span>'],
    responsive: {
      0: {
        items: 1,
      },
      470: {
        items: 2,
      },
      1200: {
        items: 4,
      },
    },
  });
});


